//创建throttle.js
const throttle = (fn, delay) => {
    let last = 0
    return function () {
        const now = Date.now()
        if (now - last >= delay) {
            fn.apply(this, arguments)
            last = now
        }
    }
}

export default {
    mounted(el, binding) {
        const { value, arg } = binding
        const delay = arg ? parseInt(arg, 10) : 3000

        const throttledClick = throttle(value, delay)

        el.__throttledClick__ = throttledClick

        el.addEventListener('click', throttledClick)
    },
    beforeUnmount(el) {
        // console.log('Before unmount')
        if (el) {
            // console.log(el)
            // console.log(el.__throttledClick__)
            el.removeEventListener('click', el.__throttledClick__)
            delete el.__throttledClick__
        }
    }
}

